import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import { FullscreenControl as FullscreenControl$1 } from "@pbe/react-yandex-maps";
import Button from "../../../../Button/Button.js";
import Icon from "../../../../Icon/Icon.js";
import classnames from "../../../../../utils/classnames.js";
import './FullscreenControl.css';/* empty css                       */
function convertTopPosition(occupiedAreas) {
  let topPosition = 80;
  if (!occupiedAreas) {
    return topPosition;
  }
  occupiedAreas.forEach((item) => {
    if (item.top !== void 0 && item.height && item.height !== "100%") {
      topPosition = item.height;
    }
  });
  return topPosition;
}
const FullscreenControl = ({
  className,
  onPress,
  occupiedAreas
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const ref = useRef(null);
  const topOffset = convertTopPosition(occupiedAreas);
  const handleKeyDown = (e) => {
    if (e.keyCode === 27) {
      handleMinimize();
    }
  };
  const handleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
    onPress == null ? void 0 : onPress();
  };
  const handleMinimize = () => {
    setIsFullscreen(false);
    onPress == null ? void 0 : onPress();
  };
  useEffect(() => {
    if (isFullscreen) {
      window.addEventListener("onkeydown", handleKeyDown);
      return () => {
        window.removeEventListener("onkeydown", handleKeyDown);
      };
    }
  }, [isFullscreen]);
  return /* @__PURE__ */ jsxs("div", { style: { top: topOffset }, className: classnames("perxis-auto-map-fullscreen-control", className), children: [
    isFullscreen ? /* @__PURE__ */ jsx(
      Button,
      {
        className: classnames("perxis-auto-map-fullscreen-control-button"),
        type: "ghost",
        onClick: handleMinimize,
        icon: /* @__PURE__ */ jsx(Icon, { name: "minimize", size: 20, sticker: "map-fullscreen-minimize-icon" }),
        onKeyDown: handleKeyDown
      }
    ) : /* @__PURE__ */ jsx(
      Button,
      {
        className: classnames("perxis-auto-map-fullscreen-control-button"),
        type: "ghost",
        onClick: handleFullscreen,
        icon: /* @__PURE__ */ jsx(Icon, { name: "expand", size: 20, sticker: "map-fullscreen-expand-icon" })
      }
    ),
    /* @__PURE__ */ jsx(FullscreenControl$1, { instanceRef: ref, options: { visible: false } })
  ] });
};
export {
  FullscreenControl as default
};
//# sourceMappingURL=FullscreenControl.js.map
